<template>
    <div class="inline-block">
        <OptionItem
            v-for="option in options"
            :key="option.text"
            :color="option.color"
            :icon="option.icon"
            :text="option.text"
            :value="option.value"
        />
    </div>
</template>

<script lang="ts" setup>
import {BoltIcon, ChatBubbleLeftEllipsisIcon, ClockIcon, SparklesIcon,} from "@heroicons/vue/24/outline";

import {computed} from "vue";
import OptionItem from "@src/components/views/HomeView/MainArea/FooterArea/OptionsSelector/OptionItem.vue";
import {Option} from "@src/types";
import {permissionsHelper} from "@src/helpers/permissionsHelper";
import {useChatSessionStore} from "@src/stores/chatSession";

const sessionStore = useChatSessionStore()
const options = computed<Option[]>(() => {
    const baseOptions: Option[] = [
        {
            icon: ChatBubbleLeftEllipsisIcon,
            text: 'Adicionar Comentário',
            color: 'bg-blue-600 hover:bg-blue-700',
            value: 'comments'
        },
        {
            icon: BoltIcon,
            text: 'Modelos de mensagens',
            color: 'bg-green-600 hover:bg-green-700',
            value: 'templates'
        },
    ];

    if (permissionsHelper.has('module_ia')) {
        baseOptions.push({
            icon: SparklesIcon,
            text: 'Sugestão mensagens',
            color: 'bg-purple-600 hover:bg-purple-700',
            value: 'suggestions'
        });
    }
    if (sessionStore.selectedSession?.channel?.type === 'whatsapp' || sessionStore.selectedSession?.channel?.type === 'waapi') {
        baseOptions.push({
            icon: ClockIcon,
            text: 'Agendar mensagens',
            color: 'bg-yellow-600 hover:bg-yellow-700',
            value: 'schedule'
        });
    }

    return baseOptions;
});
</script>

<style scoped>
</style>